import apiClient from '../apiClient';
import { PUT_CITY_URL } from '../apiUrl';

const putCityApi = (id, data) => {
  return apiClient.put(PUT_CITY_URL(id), data);
};

export default putCityApi;
